import { get, post } from '@/infrastructure/http-client/axios';

export const apiLogin = async (platform, payload) =>
  await post(`/webPlataforms/login/${platform}`, payload);
export const apiStatusSession = async () =>
  await get('/webPlataforms/statusSession/', {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
  });
export const apiLogout = async (platform) =>
  await post(`/webPlataforms/logout/${platform}`, null, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
  });
